import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { manageActions, commonActions, alertActions } from '../../../store/actions'
import moment from 'moment'
import InvtPopup from './InvtPopup'
import SendInvitEmailPopup from './SendInvitEmailPopup'

// 초대하기 Tab
export const InviteUseTab2 = (props) => {
  const queryString = require('query-string')

  const [state, setState] = useState({
    isShowInvt: false, // 초대하기 팝업 입력창
    isShowSendInvtEmeil: false, // 초대하기 팝업 입력창
    isType: '', // 초대하기 or 이메일보내기
    groupCode: '',
  })

  const [checkedUsers, setCheckedUsers] = useState([])
  const [inviteList, setInviteList] = useState([])
  const [isDrop, setIsDrop] = useState(false)

  useEffect(() => {
    const parsed = queryString.parse(props.search)

    setState({
      ...state,
      parsed,
    })

    // 사업자 정보 변경 초기 조회
    props.getGroupInfo()
    // 사업자 이용자 초대화면 초기 로딩
    props.readInviteList2(parsed)
    // 공통코드 조회
    props.common({ mainCd: ['INVT_STATE_CD', 'USER_SE_CD'] }) // let obj = Object.assign(state.co, action.response.data?.payload);  co: obj, isFailure: false,
  }, [])

  //group 정보 셋팅
  useEffect(() => {
    setState({
      ...state,
      groupCode: props.groupInfo?.groupCode,
    })
  }, [props?.groupInfo])

  // 리스트 변경되면 paging관련 데이터 셋팅 및 checked 추가하여 state로 담아둠
  useEffect(() => {
    if (
      props?.inviteList === undefined ||
      props?.inviteList.length === null ||
      props?.inviteList.length === undefined ||
      props?.inviteList?.length < 1
    ) {
      setInviteList([])
      return
    }

    let arr = [...props.inviteList]

    arr.map((info) => {
      info.checked = false
    })

    setInviteList(arr)
  }, [props?.inviteList])

  useEffect(() => {
    if (props.isUpdate) {
      // 저장/수정 성공시
      props.success({
        title: '성공',
        message: '성공하였습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            localStorage.setItem('invtTab', '2')
            window.location.reload()
          },
        },
      })
    }
  }, [props.isUpdate])

  useEffect(() => {
    if (props.isDrop) {
      props.success({
        title: '탈퇴',
        message: '선택된 사용자가 탈퇴되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            localStorage.setItem('invtTab', '2')
            window.location.reload()
          },
        },
      })
    }

    if (props.isDrop === false && isDrop) {
      props.success({
        title: 'ERROR',
        message: '오류가 발생했습니다.\n이 오류가 지속되면 관리자에게 문의하세요.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            localStorage.setItem('invtTab', '2')
            window.location.reload()
          },
        },
      })
    }
  }, [props.isDrop])

  useEffect(() => {
    if (props.isFailure) {
      // 저장/수정 실패시
      props.success({
        title: '실패',
        message: '실패하였습니다.\n' + props.errorMessage,
        params: {
          type: 'ERROR',
          callback: () => {
            localStorage.setItem('invtTab', '2')
            window.location.reload()
          },
        },
      })
    }
  }, [props.isFailure])

  // 초대취소 버튼 클릭
  const cancelInviteUser = (e) => {
    e.preventDefault()
    let isCancelValid = true

    const list = inviteList.filter((info) => info.checked === true)

    // 유효성 체크
    if (list.length < 1) {
      props.error({
        title: '초대취소불가',
        message: '초대취소시킬 사용자를 선택하세요.',
      })
      return
    }

    // invtStateCd = 01:초대대기, 02:초대중
    list.forEach((child) => {
      if (child.invtStateCd !== '02' && child.invtStateCd !== '01') isCancelValid = false
    })

    if (!isCancelValid) {
      props.error({
        title: '취소불가',
        message: '초대취소 가능한 상태가 아닙니다.',
      })
      return
    }

    // 초대취소 날리기
    props.confirm({
      title: '확인',
      message: '정말 취소하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          list.forEach((child) => {
            child.canclYn = 'Y'
            const { canclYn, email, groupCode, invtSno, invtStateCd, userName, userSeCd } = child
            // 이용자 정보 저장/수정
            props.updateManageUser({ canclYn, email, groupCode, invtSno, invtStateCd, userName, userSeCd })
          })
        },
      },
    })
  }

  const changeHandler = (e) => {
    const { id, value, checked } = e.target

    if (checked) {
      setCheckedUsers([...checkedUsers, value])
    } else {
      setCheckedUsers(checkedUsers.filter((value) => value !== value))
    }

    inviteList.map((item, index) => {
      if (index == id) {
        item.checked = !item.checked
      }
    })
  }

  const cancel = () => {
    setState({ ...state, isShowInvt: false })
  }

  // 초대메일 발송 닫기
  const closeInviteEmail = () => {
    setState({
      ...state,
      isShowSendInvtEmeil: false,
    })
  }

  // 선택탈퇴 버튼 클릭
  const DropUser = (e) => {
    e.preventDefault()

    let isDropValid = true
    let invtSnoArr = []
    const list = inviteList.filter((info) => info.checked === true)
    // 유효성 체크
    if (list.length < 1) {
      props.error({
        title: '탈퇴불가',
        message: '탈퇴시킬 사용자를 선택하세요.',
      })
      return
    }

    list.forEach((info) => {
      if (info.invtStateCd !== '03') isDropValid = false
      invtSnoArr.push(info.invtSno)
    })

    if (!isDropValid) {
      props.error({
        title: '탈퇴불가',
        message: '초대가 완료되지 않은 사용자는 탈퇴시킬 수 없습니다.',
      })
      return
    }

    props.confirm({
      title: '확인',
      message: '정말 탈퇴하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          setIsDrop(true)
          props.updateInviteUserDrop({ invtSno: invtSnoArr })
        },
      },
    })
  }

  const sendEmail = (e) => {
    e.preventDefault()

    let isSendEmailValid = true

    if (checkedUsers.length === 0) {
      props.error({
        title: '전송불가',
        message: '이메일을 전송할 고객이 없습니다. 확인해주세요.',
      })
      return
    }

    // checkedUsers.forEach((number) => {
    //   if (inviteList[number]?.invtStateCd !== '02') {
    //     isSendEmailValid = false
    //   }
    // })
    checkedUsers.forEach((user) => {
      if(JSON.parse(user).invtStateCd !== '02') {
        isSendEmailValid = false
      }
    })

    // 초대완료일 경우 Error Message return
    if (!isSendEmailValid) {
      props.error({
        title: '취소불가',
        message: '초대가 완료된 사용자는 초대메일을 재발송할 수 없습니다.',
      })
      return
    }

    setState({ ...state, isShowSendInvtEmeil: true })
  }

  function InviteUser({ user, index }) {
    return (
      <tr>
        <td>
          <input
            type="checkbox"
            id={index}
            name={user.invtSno}
            value={JSON.stringify(user)}
            onClick={(e) => changeHandler(e)}
            defaultChecked={user.checked}
          />
          <em />
        </td>
        <td>{user.userName}</td>
        {/* <td>{user.memberId}</td> */}
        <td>{user.email}</td>
        <td>법인이용자</td>
        <td>{user.invtStateCdName}</td>
        <td>{user.regDt == '' ? '' : moment(user.invtDt).format('YYYY.MM.DD hh:mm')}</td>
      </tr>
    )
  }

  return (
    <div id="use-tab2" className="tab-cont">
      <div className="list-header">
        <span className="total-num">
          전체 <em>{checkedUsers.length}</em>건 선택
        </span>
      </div>
      <div className="tbl-wrap mobile-scroll">
        <table className="tbl-list">
          <caption>선택, 이름, 이메일, 권한, 상태, 요청일시 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '6%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '22%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">선택</th>
              <th scope="col">이름</th>
              <th scope="col">이메일</th>
              <th scope="col">권한</th>
              <th scope="col">상태</th>
              <th scope="col">요청일시</th>
            </tr>
          </thead>
          <tbody>
            {inviteList?.length > 0 ? (
              inviteList.map((user, index) => <InviteUser user={user} key={user?.invtSno ? user?.invtSno : index} index={index} />)
            ) : (
              <tr>
                <td className="center" colSpan={6}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="btn-block center">
        <a href="#" className="btn-primary lg w150 cursor" onClick={DropUser}>
          선택탈퇴
        </a>
        <a href="#" className="btn-secondary lg w150 cursor" onClick={cancelInviteUser}>
          초대취소하기
        </a>
        <a href="#" className="btn-secondary lg w150 cursor" onClick={sendEmail}>
          초대메일 재발송
        </a>
        <span className="right2">
          <a href="#" className="btn-primary lg w150 cursor green" onClick={() => setState({ ...state, isShowInvt: true })}>
            신규 사용자 초대
          </a>
        </span>
      </div>
      {state.isShowInvt === true && <InvtPopup isShowInvt={state.isShowInvt} onChange={cancel} groupCode={state.groupCode} />}
      {state.isShowSendInvtEmeil === true && (
        <SendInvitEmailPopup close={closeInviteEmail} users={inviteList} checkedUsers={checkedUsers} groupCode={state.groupCode} />
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  groupInfo: state.manage?.data,
  inviteList: state.manage?.inviteList,
  checkInfo: state.manage.checkInfo,
  isUpdate: state.manage.isUpdate,
  isDrop: state.manage.isDrop,
  isFailure: state.manage.isFailure,
  errorMessage: state.manage.errorMessage,
})

const mapDispatchToProps = {
  getGroupInfo: manageActions.getGroupInfo,
  readInviteList2: manageActions.readInviteList2,
  common: commonActions.getCommonCode,
  checkManageUser: manageActions.checkManageUser,
  error: alertActions.error,
  success: alertActions.success,
  confirm: alertActions.confirm,
  updateManageUser: manageActions.updateManageUser,
  updateInviteUserDrop: manageActions.updateInviteUserDrop,
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteUseTab2)
